import React, { useCallback, useState } from 'react'
// import PropTypes from 'prop-types'
import useEventListener from '../../hooks/useEventListener';

import './404.scss'

const Page404 = props => {

  const [coords, setCoords] = useState({ x: 0, y: 0 });

  const handler = useCallback(
    ({ clientX, clientY }) => {
      // Update coordinates
      setCoords({ x: clientX, y: clientY });
    },
    [setCoords]
  );

  useEventListener('mousemove', handler);

  return (
    <div
      className='page404-container'
      style={{ backgroundPositionX: coords.x/10, backgroundPositionY: coords.y/10 }}
      >
      <div className='page404-content'>
        <h2>404</h2>
        <h4>Oops! Pagina no encontrada</h4>
        <p>La pagina que busca no existe. Puede que haya escrito mal la ruta o la pagina ha sido movida</p>
        <a href="/">{"Volver"}</a>
      </div>
    </div>
  )
}

Page404.propTypes = {

}

export default Page404
